import React, {useState} from "react";
import * as Sentry from '@sentry/browser';
import Api from "../../Api";
import {withAuth} from "../../hoc/Auth";
import {Column, Container, Wrapper} from "../../hoc/Layout";
import MerchantTerminalSelect from "../../Components/MerchantTerminalSelect";
import Loader from "../../Components/Utils/Loader";
import classes from "./styles.module.css";

var Refills = withAuth(function(props) {
    var token = props.token;

    var stateEntries = useState([]);
    var entries = stateEntries[0];
    var setEntries = stateEntries[1];

    var stateLoading = useState(true);
    var loading = stateLoading[0];
    var setLoading = stateLoading[1];

    var stateSelectedMs = useState("");
    var setSelectedMs = stateSelectedMs[1];

    function loadRefills(api, msId) {
        setLoading(true);
        var now = new Date();
        var from = new Date(now.getTime() - 90 * 24 * 60 * 60 * 1000);
        var dateFrom = from.toISOString().split('T')[0];
        var dateTo = now.toISOString().split('T')[0];
        api.getMerchantStatement({
            merchant_settings_id: msId,
            date_from: dateFrom,
            date_to: dateTo,
            limit: 200
        }).then(function(r) {
            // Filter only TOPUP(8) and SETTLEMENT_PAYOUT(3) entries
            var filtered = (r.entries || []).filter(function(e) {
                return e.type === 8 || e.type === 3;
            });
            setEntries(filtered);
            setLoading(false);
        }).catch(function(err) {
            Sentry.captureException(err);
            setLoading(false);
        });
    }

    function handleMsSelect(msId) {
        setSelectedMs(msId);
        if (msId) {
            var api = new Api({token: token});
            loadRefills(api, msId);
        }
    }

    return (
        <Wrapper>
            <Container style={{justifyContent: 'center'}}>
                <Column width={1180}>
                    <div className={classes.Card}>
                        <div className={classes.Header}>
                            <h5 className={classes.Title}>Пополнения</h5>
                        </div>
                        <div className={classes.Content}>
                            <div className={classes.SelectorBlock}>
                                <MerchantTerminalSelect
                                    mode="user"
                                    token={token}
                                    stackOnMobile={true}
                                    onSelect={handleMsSelect}
                                    onDataLoaded={function() { setLoading(false); }}
                                />
                            </div>

                            {loading ? <Loader/> : (
                                <div className={classes.TableWrap}>
                                    <table className="table table-hover">
                                        <thead>
                            <tr>
                                <th>Дата</th>
                                <th>Тип</th>
                                <th>Сумма</th>
                                <th>Баланс после</th>
                                <th>Описание</th>
                            </tr>
                                        </thead>
                                        <tbody>
                            {entries.map(function(entry) {
                                return (
                                    <tr key={entry.id}>
                                        <td>{new Date(entry.created_at).toLocaleString('ru-RU')}</td>
                                        <td>{entry.type_name}</td>
                                        <td>{(entry.amount_float).toFixed(2)}</td>
                                        <td>{(entry.balance_after_float).toFixed(2)}</td>
                                        <td>{entry.description || ''}</td>
                                    </tr>
                                );
                            })}
                            {entries.length === 0 && (
                                <tr>
                                    <td colSpan="5" className="text-center text-muted">Нет записей</td>
                                </tr>
                            )}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div>
                </Column>
            </Container>
        </Wrapper>
    );
});

export default Refills;



// WEBPACK FOOTER //
// ./src/PagesOfUser/Refills/index.js